
import { defineComponent, PropType } from "vue";
import { BucketData } from "@/types/service";

export default defineComponent({
  name: "bucket-item",
  props: {
    data: {
      type: Object as PropType<BucketData>,
    },
  },
  methods: {
    onChangeHandler() {
      this.$emit("onCheckboxHandler", this.data?.id);
    },
    onDelete() {
      this.$emit("onDeleteHandler", this.data?.id);
    },
  },
});
